<template>
  <section class="coverse__container">
    <h2>Почему Coverse?</h2>
    <div class="coverse__switcher">
      <progress-switcher :items="switcher" />
    </div>
    <div class="cta__container">
      <div class="cta__wrapper">
        <div>
          <p>Автоматизируйте рутину и управляйте бизнесом без лишних сложностей и рисков!</p>
          <a target="_blank" :href="signupUrl" class="ui-button-primary mod_rounded-size-s button">
            Попробовать бесплатно
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ProgressSwitcher from "@/components/main/partials/ProgressSwitcher";

export default {
  name: 'Coverse',
  components: {
    ProgressSwitcher
  },
  data() {
    return {
      switcher: [{
        image: 'images/v4/images/coverse/image-why-coverse-1@2x.webp',
        title: 'Гибкая коллаборация в&nbsp;реальном времени',
        text: 'Одновременное редактирование текстовых и&nbsp;табличных документов несколькими участниками ускоряет согласование и принятие решений более чем в 2 раза.',
      }, {
        image: 'images/v4/images/coverse/image-why-coverse-2@2x.webp',
        title: 'Контроль над рабочим процессом',
        text: 'Интуитивно понятный интерфейс и простая логика работы обеспечат быстрый старт без необходимости в обучении.',
      }, {
        image: 'images/v4/images/coverse/image-why-coverse-3@2x.webp',
        title: 'Низкая потребность в ресурсах',
        text: 'Оптимизированная платформа не «тормозит» даже при множестве открытых вкладок в браузере и одновременной работе большого количества участников.',
      }, {
        image: 'images/v4/images/coverse/image-why-coverse-4@2x.webp',
        title: 'Отечественное решение без риска блокировок',
        text: 'Данные хранятся в РФ, 100% гарантия доступа к документам без риска блокировок Google. Соответствие российским нормам законодательства и безопасности.',
      }],
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";
@import "@/styles/button-primary.scss";

.coverse__container {
  max-width: 1000px;
  margin: 0 auto 90px;

  h2 {
    font-size: 40px;
    font-weight: 700;
    line-height: 40px;
    text-align: center;
    margin: 0 0 72px;
  }

  .coverse__switcher {
    min-height: 380px;
  }

  .cta__container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 90px auto 0;

    .cta__wrapper {
      display: flex;
      max-width: 800px;
      width: 100%;
      height: 240px;
      border-radius: 20px;
      padding: 50px 60px;
      overflow: hidden;
      background-image: url('/images/v4/images/coverse/image-cta-1@2x.webp');
      background-size: cover;
      background-repeat: no-repeat;

      div {
        position: relative;
        width: 100%;
        flex: 1 0 auto;
      }
    }

    p {
      max-width: 540px;
      font-size: 20px;
      font-weight: 600;
      line-height: 34px;
      color: #ffffff;
      margin: 0;
    }

    .button {
      width: 270px;
      position: absolute;
      right: 0;
      bottom: 0;
      font-size: 17px;
      color: #333334;
      background-color: #ffffff;
    }
  }
}

@include media-breakpoint-down($size-tablet) {
  .coverse__container {
    margin: 0 auto 70px;

    .coverse__switcher {
      max-width: 500px;
      margin: 0 auto;
    }

    h2 {
      font-size: 34px;
      margin: 0 0 38px;
    }

    .cta__container {
      padding: 0 30px;
      margin: 70px auto 0;

      .cta__wrapper {
        padding: 50px 30px;
      }
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .coverse__container {
    padding: 0 20px;
    margin: 0 auto 55px;

    h2 {
      font-size: 24px;
      margin: 0 0 25px;
    }

    .cta__container {
      padding: 0;
      margin: 55px auto 0;

      .cta__wrapper {
        height: 260px;
        padding: 50px 15px 42px;
        background-position: 65%;
      }

      p {
        font-size: 16px;
        line-height: 26px;
        text-align: center;
        padding: 0 19px;
      }

      .button {
        width: 100%;
        height: 40px;
        font-size: 17px;
        line-height: 40px;
      }
    }
  }
}
</style>
